




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { TransactionGateWay } from '@/modules/transaction/models/transaction-resource.model'

@Component
export default class TransactionGateWayView extends Vue {
  @Prop({ required: true }) gateway: TransactionGateWay
  @Prop({ required: true }) gateways!: { [key in TransactionGateWay]: string }
  @Prop({ default: false }) dark: boolean

  get gatewayColor() {
    switch (this.gateway) {
      case TransactionGateWay.CARD:
        return 'text-green'
      case TransactionGateWay.WALLET:
        return 'text-red'
      case TransactionGateWay.ONLINE:
        return 'text-blue'
      default:
        return ''
    }
  }
}
